export const AYS_CODE_DRG_INEK_DEPARTMENTS = [
    'NORMAL_WARD_01',
    'INTENSIVE_CARE_UNIT_02',
    'DIALYSIS_DEPARTMENT_03',
    'SURGERY_DEPARTMENT_04',
    'ANAESTHESIA_DEPARTMENT_05',
    'LABOR_WARD_06',
    'CARDIOLOGY_07',
    'ENDOSCOPY_08',
    'RADIOLOGY_09',
    'LABORATORIES_10',
    'DIAGNOSTICS_11',
    'THERAPEUTIC_12',
    'PATIENT_ADMISSION_13'
];
export const AYS_CODE_DRG_INEK_DEPARTMENT_DISPLAY_NAMES = {
    'NORMAL_WARD_01': '1. Normalstation',
    'INTENSIVE_CARE_UNIT_02': '2. Intensivstation',
    'DIALYSIS_DEPARTMENT_03': '3. Dialyseabteilung',
    'SURGERY_DEPARTMENT_04': '4. OP-Bereich',
    'ANAESTHESIA_DEPARTMENT_05': '5. Anästhesie',
    'LABOR_WARD_06': '6. Kreißsaal',
    'CARDIOLOGY_07': '7. Kardiologische Diagnostik / Therapie',
    'ENDOSCOPY_08': '8. Endoskopische Diagnostik / Therapie',
    'RADIOLOGY_09': '9. Radiologie',
    'LABORATORIES_10': '10. Laboratorien',
    'DIAGNOSTICS_11': '11.Diagnostische Bereiche',
    'THERAPEUTIC_12': '12 Therapeutische Verfahren',
    'PATIENT_ADMISSION_13': '13. Patientenaufnahme'
};
export const AYS_CODE_DRG_INEK_DEPARTMENT_COLORS = {
    'NORMAL_WARD_01': '#e6194b',
    'INTENSIVE_CARE_UNIT_02': '#fffac8',
    'DIALYSIS_DEPARTMENT_03': '#ffe119',
    'SURGERY_DEPARTMENT_04': '#aaffc3',
    'ANAESTHESIA_DEPARTMENT_05': '#f58231',
    'CARDIOLOGY_07': '#ffd8b1',
    'ENDOSCOPY_08': '#46f0f0',
    'RADIOLOGY_09': '#808080',
    'LABORATORIES_10': '#bcf60c',
    'DIAGNOSTICS_11': '#008080',
    'THERAPEUTIC_12': '#808000',
    'PATIENT_ADMISSION_13': '#3cb44b'
};
